"use client";

import { useState } from "react";
import { Menu, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { MainNavigation } from "./main-navigation";
import { Logo } from "./logo";
import { useAuth } from "@/lib/auth/auth-context";

export function MobileMenu() {
  const [open, setOpen] = useState(false);
  const { isAuthenticated, user, login, logout } = useAuth();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden rounded-full"
          aria-label="Open menu"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-80">
        <SheetHeader className="text-left">
          <SheetTitle className="flex items-center justify-between">
            <Logo />
          </SheetTitle>
        </SheetHeader>
        <div className="mt-8">
          <MainNavigation
            className="flex-col items-start gap-2"
            onLinkClick={() => setOpen(false)}
          />
        </div>
        <div className="absolute bottom-8 left-6 right-6">
          {isAuthenticated && user ? (
            <div className="space-y-3">
              <div className="flex items-center gap-3 px-1">
                <Avatar className="h-9 w-9">
                  <AvatarImage src={user.avatarUrl ?? undefined} alt={user.name} />
                  <AvatarFallback>
                    {user.name?.substring(0, 2).toUpperCase() || "US"}
                  </AvatarFallback>
                </Avatar>
                <div className="flex flex-col">
                  <span className="text-sm font-medium">{user.name}</span>
                  <span className="text-xs text-muted-foreground">{user.email}</span>
                </div>
              </div>
              <Button
                className="w-full rounded-full"
                variant="outline"
                onClick={() => { logout(); setOpen(false); }}
              >
                <LogOut className="mr-2 h-4 w-4" />
                Выйти
              </Button>
            </div>
          ) : (
            <Button
              className="w-full rounded-full"
              variant="default"
              onClick={() => { login(); setOpen(false); }}
            >
              Войти
            </Button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
